const dev = process.env.NODE_ENV === "development";



// const API_BASE_URL = "http://annoview.uwaterloo.ca";
// export const SERVER_URL = API_BASE_URL;

// const API_BASE_URL = "http://35.192.27.201/annoview-api";
// const API_BASE_URL = "http://annoview.uwaterloo.ca/annoview-api";
// export const SERVER_URL = API_BASE_URL;

// export const SERVER_TYPE = 'server';
// export const SERVER_TYPE = 'localhost';

//
// const API_BASE_URL = "http://annoview.uwaterloo.ca";
// export const SERVER_URL = API_BASE_URL;

// // const API_BASE_URL = dev ? "http://localhost:3000" : "http://annoview.uwaterloo.ca";

// const API_BASE_URL = "http://localhost:8088";
// export const SERVER_URL = "http://localhost:8088";


// export const SERVER_TYPE = "localhost"


// local test:
// const API_BASE_URL = "http://localhost:8088";
// export const SERVER_URL = "http://localhost:8088";

// // server test:
//const BASE_HOST = "annoviewv2.uwaterloo.ca";
const BASE_HOST = "annoview.uwaterloo.ca";
const API_BASE_URL = `http://${BASE_HOST}/annoview-api`;
export const SERVER_URL = API_BASE_URL;


export const UPLOAD_TRACKS = "/api/upload_tracks";
export const TRACK_API = "/api/track";
export const META_API = "/api/meta";
export const GET_API = "/api/data";
export const FLIP_API = "/api/flip";
export const SORT_API = "/api/sort";
export const TREE_API = "/api/annotation_query";
export const SEARCH_API = "/api/annotree_search";
export const TAX_API = "/api/taxonomy_query";
export const AUTO_API = "/api/auto";
export const ADD_TRACK_API = "/api/add_track";
export const ADD_META_API = "/api/add_meta";
export const INTERMEDIATE_API = "/api/annotree_search_hits";
export const PLOT_API = "/api/annotree_search_plot";
export const EVALUE_PLOT_API = "/api/annotree_search_plot_evalue";
export const CSV_EXPORT = "/api/csv_export";
export const SEQ_SEARCH = '/api/sequence_search';

export const KEGG_SEARCH = '/api/kegg_search';
export const PFAM_SEARCH = '/api/pfam_search';
export const TIGRFAM_SEARCH = '/api/tigrfam_search';

export const FLOW_CALCULATION = '/api/flow_calculation';

export const GET_TREE = '/api/get_phylotree';

export const POST_TRACK = "track";
export const POST_META = "meta";

export const EMAIL_SERVICE_ID = "service_ut9va74";

export const EMAIL_TEMPLATE_ID_1 = "template_3ok70g4";
export const EMAIL_TEMPLATE_ID_2 = "template_razms7f";

export const EMAIL_USER_ID = "cXe0BqzlGC3tbPvXr";

export const PROGRESS_CHECK = "/api/search_progress_check";
export const QUEUE_CHECK = "/api/search_queue_check";


export const AUTOCOMPLETE_SEARCH = "/api/annotool_autocomplete";
export const GENE_CLUSTER_SEARCH = "/api/annotool_cluster_search";
export const GENE_CLUSTER_HITS = "/api/annotool_cluster_hits";

export const TAXONOMY_DISTRIBUTION = "/api/annotool_taxonomy_distribution";

export const SIMILAR_WORDS = "/api/semantic_similar_words";

// export const ANNOTREE_BACKEND_URL = "http://20.151.176.175/annotree-api"
// export const ANNOTREE_URL = "http://20.151.176.175/"


export const ANNOTREE_BACKEND_URL = `http://${BASE_HOST}/annotree-api`
export const ANNOTREE_FRONTEND_URL = `http://${BASE_HOST}/annotree/app`
export const ANNOTREE_URL = `http://${BASE_HOST}/annotree-api`

// export const ANNOTREE_BACKEND_URL = "http://localhost:5050"
// export const ANNOTREE_FRONTEND_URL = "http://localhost:8080"
// export const ANNOTREE_URL = "http://localhost:5050"


export const ANNOTREE_BACKEND_HITS = "/annoview/get_distribution"



export const SERVER_PREFIX = "/annoview"
// export const SERVER_PREFIX = ""
